import React from 'react'

interface ShowProps<T> {
  when: T | undefined | null | false
  children: JSX.Element | JSX.Element[]
  fallback?: JSX.Element
}

export default function <T> ({ when, children, fallback }: ShowProps<T>) {
  return (
    <>
      { !!when && children }
      { !when && fallback }
    </>
  )
}
